/** Fixed locale so currency reads as `CHF 100.00` regardless of UI language. */
const CURRENCY_FORMAT_LOCALE = 'en-CH';

export function normalizeCurrency(currency: string): string {
  return currency.trim().toUpperCase() || 'CHF';
}

export function formatCurrencyAmount(
  amountMajor: number,
  currency: string
): string {
  const code = normalizeCurrency(currency);
  try {
    return new Intl.NumberFormat(CURRENCY_FORMAT_LOCALE, {
      style: 'currency',
      currency: code,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(amountMajor);
  } catch {
    return `${code} ${amountMajor.toFixed(2)}`;
  }
}

export function formatCurrencyFromMinor(
  amountMinor: number,
  currency: string
): string {
  return formatCurrencyAmount(amountMinor / 100, currency);
}
